import { Component, Input, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

import { ReviewViewModel } from '../../models';
import { TakePipe } from '../../shared-components/pipes/take.pipe';
import { SkipPipe } from '../../shared-components/pipes/skip.pipe';
import { PublicReviewDisplayComponent } from '../public-review-display/public-review-display.component';
import { DetailedReviewDisplayComponent } from '../detailed-review-display/detailed-review-display.component';

import { NgbModal, NgbModalRef, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'review-pager',
    templateUrl: './review-pager.component.html',
    styleUrls: ['./review-pager.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DetailedReviewDisplayComponent, PublicReviewDisplayComponent, SkipPipe, TakePipe, NgbModalModule]
})
export class ReviewPagerComponent {
  @Input() detailed = false;
  @Input() reviews: ReviewViewModel[];
  @Input() showTitle = true;

  modalReview: ReviewViewModel;
  page = 0;
  pageSize = 6;
  maxTextLength = 200;

  @ViewChild("modalDiv") modalDiv: TemplateRef<any>;

  constructor(
    private modalService: NgbModal
  ) {}

  modal: NgbModalRef;
}
